import { useEffect } from 'react';

import { StampCardDialog } from '../components/Dialogs/StampCardDialog/StampCardDialog';
import { useStores } from '../stores/useStores';

export const useRegisterStampCardDialog = () => {
  const { stampCardStore } = useStores();

  useEffect(() => {
    stampCardStore.StampCardDialogComponent = StampCardDialog;
  }, [stampCardStore]);
};
